import React from "react";
import ajax from "./../lib/ajax.js";
import {Redirect, browserHistory} from "react-router";
import Immutable from "immutable";
import FutureTCClockEdit from "./future-tc-clock-edit.jsx";
import FutureTCDuration from "./future-tc-duration.jsx";

export default class FutureTCEntry extends React.Component {    
    constructor(props) {
        super(props);
        this.state = {
            timecardType : null
        }
    }

    componentDidMount() {
        const self = this;
        let tid = self.props.location.query.tid || "";
        ajax.api()
        .get(`people/tc-type/${tid}`)
        .then(function(res) {
            const result = res.data;
            self.setState(Immutable.fromJS(self.state)
                                   .mergeDeep({timecardType : result})
                                   .toJS());
        });
    }

    render() {
        const content = this.state.timecardType === "CLOCKTC" || this.state.timecardType === "CLOCKEDITTC" ?
            <FutureTCClockEdit location={this.props.location} params={this.props.params} 
                         route={this.props.route} routes={this.props.routes} clockeditTcRoute="people/future-tc-clock-edit?edit=1&tid=:timecardId"/> : 
            this.state.timecardType === "DURATIONTC" ? 
            <FutureTCDuration location={this.props.location} params={this.props.params} 
                         route={this.props.route} routes={this.props.routes} durationTcRoute="people/future-tc-entry?edit=1&tid=:timecardId"/> : null;
        return (<div>
            {content}
        </div>);
    }
}